import { render, staticRenderFns } from "./LineItemForm.vue?vue&type=template&id=640d2020&scoped=true&"
import script from "./LineItemForm.vue?vue&type=script&lang=ts&"
export * from "./LineItemForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640d2020",
  null
  
)

export default component.exports